import { render } from "./DigitalTransform.vue?vue&type=template&id=1bae99df&scoped=true"
import script from "./DigitalTransform.vue?vue&type=script&lang=js"
export * from "./DigitalTransform.vue?vue&type=script&lang=js"

import "./DigitalTransform.vue?vue&type=style&index=0&id=1bae99df&lang=scss&scoped=true"

import exportComponent from "/Users/ganl/Code/vue-digital-transform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bae99df"]])

export default __exports__